import { LogLevel } from '@azure/msal-browser';

// Azure AD App Registration Client IDs
const CLIENT_IDS = {
  prod: 'b2d5e044-a512-4236-b93f-2abb89eb75a5',
  nonprod: '818a063e-faac-4e4b-b66d-141c09db8e20',
};

// Determine client ID based on app type and environment
const getClientId = () => {
  const hostname = window?.location?.hostname;

  // Determine if production or non-prod
  const isProduction =
    hostname === 'lanternal.harvestgroup.com' ||
    hostname === 'console.harvestgroup.com' ||
    hostname === 'lanternalprodstorage.z13.web.core.windows.net';
  return isProduction ? CLIENT_IDS.prod : CLIENT_IDS.nonprod;
};

const clientId = getClientId();

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: 'https://login.microsoftonline.com/52934c9b-912c-4480-b2bc-72fee70477bb/',
    redirectUri: window?.location?.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where cache will be stored
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequestOpenId = {
  scopes: [`api://${clientId}/access`],
};
export const loginRequest = {
  scopes: ['User.Read'],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphUserSecurityGroupsEndpoint: 'https://graph.microsoft.com/v1.0/me/memberOf',
  graphUserPhotoEndpoint: 'https://graph.microsoft.com/v1.0/me/photo/$value',
};
